import { createContext, useContext, useState } from 'react';

import { getInstance } from 'src/utils/http-client/axios';
import { useInitAxios } from 'src/utils/http-client/useInitAxios';
// import { setAuthCookies, clearAuthCookies } from 'src/utils/storage/auth';

type SignIn = (email: string, password: string) => Promise<boolean | null>;
type Register = (email: string, password: string) => Promise<boolean | null>;

export const AuthContext = createContext<{
    user: any;
    signIn: SignIn;
    register: Register;
    signOut: () => void;
}>({
    user: null,
    signIn: () => null as any,
    register: () => null as any,
    signOut: () => {}
});

export function AuthProvider({ children }: any) {
    const [user, setUser] = useState<any>(null);

    useInitAxios();
    const register: Register = async (
        email,
        password
        // redirecUrl = 'localhost;3000/get-started'
    ) => {
        return new Promise(async (resolve) => {
            try {
                const { data } = await getInstance()({
                    url: '/account/signup',
                    method: 'POST',
                    data: JSON.stringify({ email, password })
                });
                if (data.result) {
                    // setAuthCookies(data);
                    resolve(data);
                    setUser(data);
                }
                resolve(null);
            } catch (err) {
                resolve(null);
            }
        });
    };
    const signIn: SignIn = async (
        email,
        password
        // redirecUrl = 'localhost;3000/get-started'
    ) => {
        return new Promise(async (resolve) => {
            try {
                const { data } = await getInstance()({
                    url: '/account/emaillogin',
                    method: 'POST',
                    data: JSON.stringify({ email, password })
                });
                if (data.result) {
                    // setAuthCookies(data);
                    resolve(data);
                    setUser(data);
                }
                resolve(null);
            } catch (err) {
                resolve(null);
            }
        });
    };

    const signOut = () => {
        setUser(null);
        // clearAuthCookies();
    };

    return (
        <AuthContext.Provider value={{ user, register, signIn, signOut }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    return useContext(AuthContext);
};
